/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neworderenabled2Inputs */

const vi_neworderenabled2 = /** @type {(inputs: Neworderenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng mới`)
};

/**

* @param {Neworderenabled2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const neworderenabled2 = /** @type {((inputs?: Neworderenabled2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neworderenabled2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_neworderenabled2(inputs)
});
export { neworderenabled2 as "newOrderEnabled" }